import {Button, DropdownMenu} from '@wandb/components';
import React from 'react';

import {
  BASIC_CHART_PANEL_ITEMS,
  getBasicChartPanelIcon,
} from './basicChartPanelTypes';
import {type ArtifactVersionMetricChartType} from './types';

export const ArtifactVersionMetricAddPanelButton: React.FC<{
  onAddPanel: (chartType: ArtifactVersionMetricChartType) => void;
}> = ({onAddPanel}) => {
  return (
    <DropdownMenu.Trigger>
      <Button variant="secondary" endIcon="chevron-down">
        Add panel
      </Button>
      <DropdownMenu.Content>
        {BASIC_CHART_PANEL_ITEMS.map(item => (
          <DropdownMenu.Item
            key={item.type}
            id={item.type}
            onAction={() => onAddPanel(item.type)}>
            <DropdownMenu.ItemDecorationLeft
              iconProps={{icon: getBasicChartPanelIcon(item.type)}}
            />
            <DropdownMenu.ItemLabel>{item.label}</DropdownMenu.ItemLabel>
            <DropdownMenu.ItemDescription>
              {item.description}
            </DropdownMenu.ItemDescription>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Trigger>
  );
};
